import { useState } from 'react'
import style from  '../../../../sass/pages/profile/profile.module.scss'
import { validateEmail } from '../validates'
import { useTranslation } from 'react-i18next'

const EmailInput = ({state, setState, enabled}) => {
    const {t} = useTranslation();
    const [error, setError] = useState("")

    const handleChange = (e) => {
        if(!e.target.value) {
            setState("")
            setError("")
            return
        }

        setState(e.target.value)

        let err = validateEmail(e.target.value)
        if (err) {
            setError(t(err))
            return
        } else {
            setError("")
        }
    }

    return (
        <div className="grid grid-cols-8 xs:grid-cols-12 items-center">
            <span className='col-span-4 text-xs text-left font-bold'>
                {t('user.inputs.email.title')}
            </span>
            <input 
                disabled={true}
                className={`${style.input} col-span-12 xs:col-span-8`} 
                placeholder={t('user.inputs.email.placeholder')}
                onInput={handleChange}
                value={state}
            />
            {error && <div className={`${style.error} col-span-12 text-right`}>{error}</div>}
        </div>
  )
}

export default EmailInput